import styled from 'styled-components';

import { Card } from '@hivebrite/design-system/Card';

export const Grid = styled(Card).attrs({
  px: {
    _: 0,
    m: 6,
  },
  pt: {
    _: 0,
    m: 4,
  },
})`
  position: relative;
  z-index: 1;
  display: grid;
  grid-template-areas:
    'header aside'
    'extra aside'
    'main aside';
  justify-items: stretch;
  column-gap: 20px;

  > .additional-info {
    height: fit-content;
  }

  > header {
    grid-area: header;
  }

  > main {
    grid-area: main;
    min-width: 0;

    // hardcode until flag is removed.
    .five-sixths,
    .ten-twelfths {
      width: 100%;
    }
  }

  > aside {
    grid-area: aside;

    a {
      max-width: 100%;
    }
  }

  > aside {
    overflow: clip;
    overflow-clip-margin: 6px;
  }

  @media (min-width: 768px) {
    grid-template-columns: auto calc(306px - 20px - 20px);
  }

  @media (min-width: 1024px) {
    column-gap: 24px;
    grid-template-columns: auto calc(415px - 24px - 24px);
  }

  @media (min-width: 1440px) {
    grid-template-columns: auto calc(468px - 24px - 24px);
  }

  @media (max-width: 767px) {
    grid-template-columns: 1fr;
    grid-template-areas:
      'header'
      'extra'
      'aside'
      'main';

    > main,
    > aside {
      padding: 0 ${({ theme }) => theme.space[4]}px;
      width: 100%;
      overflow: hidden;
    }
  }
`;
